<template>
	<Form ref="formRef" :validation-schema="validationSchema" class="form-container">
		<div v-for="field in fields" :key="field.name" :class="['form-input', field.width]">
			<label :for="field.name">{{ field.label }}</label>
			<Field
				v-if="field.type === 'select'"
				as="select"
				:id="field.name"
				:name="field.name"
				v-model="formData[field.name]"
				:disabled="isUploading"
			>
				<option></option>
				<option v-for="option in field.options" :key="option.id" :value="option.id">
					{{ option.name }}
				</option>
			</Field>
			<div v-else-if="field.type === 'checkbox'">
				<label :for="field.name">
					<input
						type="checkbox"
						:id="field.name"
						:name="field.name"
						v-model="formData[field.name]"
						:disabled="isUploading"
					/>
					<span class="custom-checkbox"></span>
				</label>
			</div>
			<ErrorMessage :name="field.name" class="error" />
		</div>
	</Form>
</template>

<script setup lang="ts">
	import { ref, reactive, watchEffect, computed } from 'vue';
	import { Form, Field, ErrorMessage } from 'vee-validate';
	import { Schema } from 'yup';
	import { Borrower } from '@/models/loans';

	interface FormField {
		name: string;
		label: string;
		type: string;
		value: any;
		width: string;
	}

	const props = defineProps<{
		isUploading: boolean;
		borrowers: Borrower[];
		fields: Array<FormField>;
		validationSchema: Schema;
	}>();

	const formRef = ref();

	const formData = reactive<Record<string, any>>({});

	const isFormValid = computed(() => {
		formRef.value?.validate();
		return Object.keys(formRef.value?.errors).length === 0;
	});

	watchEffect(() => {
		props.fields.forEach((field) => {
			formData[field.name] = field.value;
		});
	});

	defineExpose({
		isFormValid,
		formData
	});
</script>

<style scoped src="@/assets/css/loans/form.css"></style>
